/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The AutomationdataSourceParams model module.
 * @module model/AutomationdataSourceParams
 * @version 1.0.0
 */
export class AutomationdataSourceParams {
  /**
   * Constructs a new <code>AutomationdataSourceParams</code>.
   * @alias module:model/AutomationdataSourceParams
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AutomationdataSourceParams</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AutomationdataSourceParams} obj Optional instance to populate.
   * @return {module:model/AutomationdataSourceParams} The populated <code>AutomationdataSourceParams</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AutomationdataSourceParams();
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('value'))
        obj.value = ApiClient.convertToType(data['value'], 'String');
    }
    return obj;
  }
}

/**
 * Allowed values for the <code>name</code> property.
 * @enum {String}
 * @readonly
 */
AutomationdataSourceParams.NameEnum = {
  /**
   * value: "collection"
   * @const
   */
  collection: "collection",

  /**
   * value: "dataset"
   * @const
   */
  dataset: "dataset",

  /**
   * value: "table"
   * @const
   */
  table: "table",

  /**
   * value: "append"
   * @const
   */
  append: "append",

  /**
   * value: "batchSize"
   * @const
   */
  batchSize: "batchSize",

  /**
   * value: "partitionBy"
   * @const
   */
  partitionBy: "partitionBy",

  /**
   * value: "clusterBy"
   * @const
   */
  clusterBy: "clusterBy",

  /**
   * value: "fieldsMatched"
   * @const
   */
  fieldsMatched: "fieldsMatched",

  /**
   * value: "url"
   * @const
   */
  url: "url",

  /**
   * value: "contentType"
   * @const
   */
  contentType: "contentType"
};
/**
 * @member {module:model/AutomationdataSourceParams.NameEnum} name
 */
AutomationdataSourceParams.prototype.name = undefined;

/**
 * @member {String} value
 */
AutomationdataSourceParams.prototype.value = undefined;

